import React, { useEffect, useState } from "react";
import { db } from "../../firebase";
import {
  collection,
  getDocs,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
} from "firebase/firestore";
import Swal from "sweetalert2";
import axios from "axios";

export default function ManageEkstrakurikuler() {
  const [list, setList] = useState([]);
  const ref = collection(db, "ekstrakurikuler");

  const fetchData = async () => {
    const snap = await getDocs(ref);
    const data = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
    setList(data);
  };

  useEffect(() => {
    fetchData();
  }, []);

  // ================= CLOUDINARY =================
  const uploadToCloudinary = async (file) => {
    const data = new FormData();
    data.append("file", file);
    data.append(
      "upload_preset",
      process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET
    );

    const res = await axios.post(
      `https://api.cloudinary.com/v1_1/${process.env.REACT_APP_CLOUDINARY_CLOUD_NAME}/image/upload`,
      data
    );
    return res.data.secure_url;
  };

  // ================= ADD / EDIT MODAL =================
  const openFormModal = async (item = null) => {
    const isEdit = !!item;

    const { value: form } = await Swal.fire({
      title: isEdit ? "Edit Ekstrakurikuler" : "Tambah Ekstrakurikuler",
      width: "700px",
      html: `
        <div style="max-height:65vh; overflow-y:auto; text-align:left; padding-right:8px;">
          <style>
            label { font-weight:600; margin-top:10px; display:block; }
            .swal2-input, .swal2-textarea, .swal2-file {
              width:100% !important;
              margin:6px 0 12px 0;
            }
          </style>

          <label>Nama Kegiatan</label>
          <input id="nama" class="swal2-input" value="${item?.nama || ""}">

          <label>Deskripsi</label>
          <textarea id="deskripsi" class="swal2-textarea">${
            item?.deskripsi || ""
          }</textarea>

          <label>Jadwal</label>
          <input id="jadwal" class="swal2-input" value="${
            item?.jadwal || ""
          }" placeholder="Contoh: Senin, 15.00 - 17.00">

          <label>Upload Gambar (Opsional)</label>
          <input id="gambarFile" type="file" class="swal2-file">

          <label>Atau URL Gambar</label>
          <input id="gambarUrl" class="swal2-input" value="${
            item?.gambar || ""
          }">
        </div>
      `,
      showCancelButton: true,
      confirmButtonText: isEdit ? "Update" : "Simpan",
      cancelButtonText: "Batal",
      preConfirm: () => {
        const nama = document.getElementById("nama").value;
        if (!nama) {
          Swal.showValidationMessage("Nama kegiatan wajib diisi");
          return false;
        }

        return {
          nama,
          deskripsi: document.getElementById("deskripsi").value,
          jadwal: document.getElementById("jadwal").value,
          gambarFile: document.getElementById("gambarFile").files[0],
          gambarUrl: document.getElementById("gambarUrl").value,
        };
      },
    });

    if (!form) return;

    try {
      Swal.fire({
        title: "Menyimpan...",
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading(),
      });

      let gambarFinal = form.gambarUrl || "";
      if (form.gambarFile) {
        gambarFinal = await uploadToCloudinary(form.gambarFile);
      }

      const payload = {
        nama: form.nama,
        deskripsi: form.deskripsi,
        jadwal: form.jadwal,
        gambar: gambarFinal,
      };

      if (isEdit) {
        await updateDoc(doc(db, "ekstrakurikuler", item.id), payload);
        Swal.fire("Berhasil!", "Kegiatan diperbarui", "success");
      } else {
        await addDoc(ref, payload);
        Swal.fire("Berhasil!", "Kegiatan ditambahkan", "success");
      }

      fetchData();
    } catch (err) {
      console.error(err);
      Swal.fire("Error!", "Gagal menyimpan data", "error");
    }
  };

  // ================= DELETE =================
  const handleDelete = async (id) => {
    const confirm = await Swal.fire({
      title: "Hapus kegiatan ini?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Ya, hapus",
    });
    if (!confirm.isConfirmed) return;

    await deleteDoc(doc(db, "ekstrakurikuler", id));
    Swal.fire("Terhapus!", "Kegiatan berhasil dihapus", "success");
    fetchData();
  };

  // ================= RENDER =================
  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3>Kelola Ekstrakurikuler</h3>
        <button
          className="btn btn-primary"
          onClick={() => openFormModal()}
        >
          + Tambah Ekstrakurikuler
        </button>
      </div>

      <div className="row">
        {list.length === 0 ? (
          <p>Belum ada kegiatan</p>
        ) : (
          list.map((e) => (
            <div key={e.id} className="col-md-4 mb-3">
              <div className="card shadow-sm h-100">
                {e.gambar && (
                  <img
                    src={e.gambar}
                    className="card-img-top"
                    style={{ height: "180px", objectFit: "cover" }}
                    alt={e.nama}
                  />
                )}
                <div className="card-body">
                  <h5>{e.nama}</h5>
                  <p className="small mb-1">{e.jadwal}</p>
                  <p className="text-muted small">{e.deskripsi}</p>
                  <div className="d-flex justify-content-end">
                    <button
                      className="btn btn-secondary btn-sm me-1"
                      onClick={() => openFormModal(e)}
                    >
                      Edit
                    </button>
                    <button
                      className="btn btn-danger btn-sm"
                      onClick={() => handleDelete(e.id)}
                    >
                      Hapus
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
